import AxiosInterceptor from "../utils/AxiosInterceptor";

const apiAuctions = {
  getAllAuctions: (values) => AxiosInterceptor().post(`/getAllAuction`, values),
  getAuctionById: (values) => AxiosInterceptor().post(`/getAuctionById`, values),
  addAuction: (values) => AxiosInterceptor().post(`/createAuction`, values),
  editAuction: (value) => AxiosInterceptor().post(`/updateAuction`, value),
  deleteAuction: (value) => AxiosInterceptor().post(`/deleteAuction`, value),
  changeStatus: (value) => AxiosInterceptor().post(`/auctionStatus`, value),
  cancelAuction: (value) => AxiosInterceptor().post(`/cancelAuction`, value),
  approveBid: (value) => AxiosInterceptor().post(`/approveBid`, value),
  rejectBid: (value) => AxiosInterceptor().post(`/rejectBid`, value),
  getAuctionStats: () => AxiosInterceptor().get(`/auction/get-auction-stats`),
  getAuctionTypes: () => AxiosInterceptor().get(`/auction/get-auction-types`),
  getVehiclesForAuction: () => AxiosInterceptor().get(`/auction/get-vehicles-for-auction`),
  scheduleAuction: (value) => AxiosInterceptor().post(`/scheduleAuction`, value),
  endAuction: (value) => AxiosInterceptor().post(`/endAuction`, value),
  getAuctionBids: (value) => AxiosInterceptor().post(`/getAuctionBids`, value),
  verifyDeposit: (value) => AxiosInterceptor().post(`/verifyDeposit`, value),
  auctionControl: (value) => AxiosInterceptor().post(`/auctionControl`, value),
  makeAuctionLiveNow: (value) => AxiosInterceptor().post(`/makeAuctionLiveNow`, value),
  blockUser: (value) => AxiosInterceptor().post(`/blockUser`, value),
  unblockUser: (value) => AxiosInterceptor().post(`/unblockUser`, value),
  getBlockedUsers: (value) => AxiosInterceptor().post(`/getBlockedUsers`, value),
};

export default apiAuctions;
